/**
 * @description
 * Positions enum
 * @enum {string}
 */
export var POSITIONS;
(function (POSITIONS) {
    POSITIONS["BOTTOM"] = "BOTTOM";
    POSITIONS["BOTTOM_CENTER"] = "BOTTOM_CENTER";
    POSITIONS["BOTTOM_LEFT"] = "BOTTOM_LEFT";
    POSITIONS["BOTTOM_LEFT_FIT_CONTENT"] = "BOTTOM_LEFT_FIT_CONTENT";
    POSITIONS["BOTTOM_RIGHT"] = "BOTTOM_RIGHT";
    POSITIONS["BOTTOM_RIGHT_FIT_CONTENT"] = "BOTTOM_RIGHT_FIT_CONTENT";
    POSITIONS["CENTER"] = "CENTER";
    POSITIONS["LEFT"] = "LEFT";
    POSITIONS["RIGHT"] = "RIGHT";
    POSITIONS["TOP"] = "TOP";
    POSITIONS["TOP_LEFT"] = "TOP_LEFT";
    POSITIONS["TOP_RIGHT"] = "TOP_RIGHT";
    POSITIONS["TOP_CENTER"] = "TOP_CENTER";
    //
    POSITIONS["LEFT_FIXED"] = "LEFT_FIXED";
    POSITIONS["BOTTOM_FIXED"] = "BOTTOM_FIXED";
    POSITIONS["RIGHT_FIXED"] = "RIGHT_FIXED";
    POSITIONS["BOTTOM_CENTER_FIXED"] = "BOTTOM_CENTER_FIXED";
    POSITIONS["TOP_CENTER_FIXED"] = "TOP_CENTER_FIXED";
    POSITIONS["LEFT_BOTTOM_FIXED"] = "LEFT_BOTTOM_FIXED";
    // custom
    POSITIONS["BOTTOM_GAP_RIGHT"] = "BOTTOM_GAP_RIGHT";
})(POSITIONS || (POSITIONS = {}));
/**
 * @description
 * Mirror positions
 * @enum {string}
 */
export const MIRROR_POSITIONS = {
    [POSITIONS.BOTTOM_CENTER]: POSITIONS.TOP_CENTER,
    [POSITIONS.TOP_CENTER]: POSITIONS.BOTTOM_CENTER,
    [POSITIONS.LEFT]: POSITIONS.RIGHT,
    [POSITIONS.RIGHT]: POSITIONS.LEFT,
    [POSITIONS.TOP]: POSITIONS.BOTTOM,
    [POSITIONS.BOTTOM]: POSITIONS.TOP,
};
//# sourceMappingURL=positions.js.map